<template>
  <div class="symposium-stage-detail" v-if="isLoaded">
    <div style="background-color: white;">
      <b-container>
        <a v-if="isMobile" href="/symposium/sessions/"
          style="display: inline-flex; align-items: center; gap: 16px; background-color: #fff; margin-top: 10px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="#828282" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span style="color: #828282;">
            Back to All Session
          </span>
        </a>
        <b-breadcrumb v-else style="background-color: #fff;">
          <b-breadcrumb-item href="/symposium/sessions/" class="cus-breadcrumb">All Session</b-breadcrumb-item>
          <b-breadcrumb-item active class="cus-breadcrumb-active">
            {{ sessionDetials?.name }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </b-container>
    </div>
    <b-container>
      <div class="stage-content" v-if="currentSesstion">
        <h1>{{ sessionDetials?.name }} </h1>
        <h2 v-if="!currentSesstion.image" class="title"><span>{{ currentSesstion.title }} </span></h2>
        <div v-else> <img loading="lazy" :src="currentSesstion.image" class="image" :alt="currentSesstion.title"></div>
        <div>
          <b-row>
            <b-col v-for="sessionItem in sessionDetials?.detail" :key="`session-item-${sessionItem.id}`" cols="12"
              md="6" lg="4">
              <div class="session-item" @click="clickSession(sessionItem)">
                <span class="time-session"> {{ sessionItem.time_start }} - {{ sessionItem.time_end }}</span>
                <img loading="lazy" class="thumbnail-session" v-if="sessionItem.thumbnail"
                  :src="`${baseURL}/storage/app/img/symposium/${sessionItem.thumbnail}`" :alt="sessionItem.name">
                <img loading="lazy" class="thumbnail-session" v-else
                  src="@/assets/images/symposium/image_placehoder.png" :alt="sessionItem.name">
                <div class="session-content">
                  <h3 class="topic">{{ sessionItem.name }}</h3>
                  <div class="speaker" v-html="sessionItem.thumbnail_speaker"></div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="other-stage">
        <h1 class="title">{{ symposiumOtherTitle }} - {{ currentSesstion.title }}</h1>
        <SessionCarousel v-for="(slider, sliderIndex) in currentSesstion.data" :key="`slider${sliderIndex}`"
          :slider="slider" :sliderKey="`sliderKey${sliderIndex}`" :slideKey="`slideKey${sliderIndex}`"
          v-show="sessionDetials.id !== slider.id" />
      </div>

      <div class="section-next-day" v-if="false">
        <h1 class="title"> {{ symposiumAnotherTitle }} - {{ nextSesstion.title }}</h1>
        <b-row class="stage">
          <b-col class="content" v-for="stageItem in nextSesstion?.data" :key="`stage-item-${stageItem.id}`" cols="6"
            md="4" lg="4" @click="clickSection(stageItem)">
            <img :src="stageItem.imgUrl" />
            <p v-if="stageItem.description">{{ stageItem.description }}</p>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

const SessionCarousel = () => import('@/components/SessionCarousel')

// const SchoolOfCreativityDetail = () =>
//   import('@/components/Creativity/SchoolOfCreativityDetail')

// custom day
// schoolCreative.id for day
const day1 = [1, 2, 3, 4, 5]
const day2 = [6, 7, 8, 9, 10]

export default {
  components: {
    // SchoolOfCreativityDetail
    SessionCarousel
  },

  data () {
    return {
      isLoaded: false,
      sectionData: [],
      sessionId: 1,
      sessionData: [],
      sectionData2: [
        {
          title: '15 NOV',
          data: []
        },
        {
          title: '16 NOV',
          data: []
        }
      ],
      testhtml: ` <ul>
    <li>ทสร บุณยเนตร</li>
    <li>ดมิสาฐ์ องค์ศิริวัฒนา</li>
    <li>ต่อศักดิ์ ชื่นประภา</li>
    <li>ภาคย์ วรรณศิริ</li>
    <li>ดิศรา อุดมเดช</li>
  </ul>`,
      currentSlide: 0,
      slidesPerView: 4,
      gap: 5
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      schoolCreativesRaw: (state) => state.creativity.schoolCreatives
    }),

    currentSesstion () {
      const { mainId } = this.$route.params
      if (day1.includes(parseInt(mainId))) {
        return this.sectionData2[0]
      } else if (day2.includes(parseInt(mainId))) {
        return this.sectionData2[1]
      }
      return null
    },
    nextSesstion () {
      const { mainId } = this.$route.params
      if (day1.includes(parseInt(mainId))) {
        return this.sectionData2[1]
      } else if (day2.includes(parseInt(mainId))) {
        return this.sectionData2[0]
      }
      return null
    },
    sessionDetials () {
      const { mainId } = this.$route.params
      return this.currentSesstion.data.filter((d) => d.id === parseInt(mainId)).pop()
    },
    symposiumOtherTitle () {
      const mConfig = this.configMap.get('symposiumOtherTitle')
      return mConfig ? mConfig.name : 'Other Stage'
    },
    symposiumAnotherTitle () {
      const mConfig = this.configMap.get('symposiumAnotherTitle')
      return mConfig ? mConfig.name : 'Another Stage'
    },

    items () {
      return this.currentSesstion.data
    }
  },

  methods: {
    clickSession (sessionItem) {
      const { mainId } = this.$route.params

      this.$router.push({
        name: 'SymposiumSessionDetail',
        params: {
          mainId: mainId,
          sessionId: sessionItem.id
        }
      })
    },
    mapSection (data) {
      this.sectionData = []
      this.sectionData2[0].data = []
      this.sectionData2[1].data = []

      data.forEach((schoolCreative) => {
        const obj = {
          id: schoolCreative.id,
          name: schoolCreative.name,
          room: schoolCreative.room,
          imgUrl: `${this.baseURL}/storage/app/img/creativeDay/${schoolCreative.image}`,
          description: schoolCreative.description,
          detail: schoolCreative.detail
        }

        // mapSection day 1
        if (day1.includes(schoolCreative.id)) {
          const stageDay1 = this.configMap.get('symposiumStageDay1')
          this.sectionData2[0].image = stageDay1?.isDisplay ? stageDay1?.image : null
          this.sectionData2[0].title = stageDay1?.isDisplay && stageDay1.name ? stageDay1.name : this.sectionData2[0].title
          this.sectionData2[0].data.push(obj)
        }

        // mapSection day 2
        if (day2.includes(schoolCreative.id)) {
          const stageDay2 = this.configMap.get('symposiumStageDay2')
          this.sectionData2[1].image = stageDay2?.isDisplay ? stageDay2?.image : null
          this.sectionData2[1].title = stageDay2?.isDisplay && stageDay2.name ? stageDay2?.name : this.sectionData2[1].title
          this.sectionData2[1].data.push(obj)
        }

        this.sectionData.push(obj)
      })
      this.isLoaded = true
    },

    mapSession (id, data) {
      this.sessionData = []

      if (data) {
        data.forEach((schoolCreative) => {
          if (id === schoolCreative.id) {
            schoolCreative.detail.forEach((detail) => {
              this.sessionData.push(detail)
            })
          }
        })
      }
    },

    clickSection (session) {
      this.$router.push({
        name: 'SymposiumStageDetail',
        params: {
          mainId: session.id
        }
      })
    },

    clickDetail () {
      this.mapDetail(this.schoolCreativesRaw)
    }

  },

  watch: {

    schoolCreativesRaw (data) {
      if (data) {
        this.mapSection(data)
      }
    },

    sectionData (data) {
      if (data) {
        this.mapSession(this.sessionId, this.schoolCreativesRaw)
      }
    },

    schoolCreativeDetail (data) {
      this.mapDetail(data)
    }
  },

  created () {
    this.$store.dispatch('creativity/getSchoolCreativity')
  },

  mounted () {
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.cus-breadcrumb {
  color: #808285;
  text-align: center;
  font-family: var(--button-default-font-family, "DB Adman X");
  font-size: var(--button-default-font-size, 20px);
  font-style: normal;
  font-weight: var(--button-default-font-weight, 400);
  line-height: normal;
}

.cus-breadcrumb-active {
  color: #DA0401;
  text-align: center;
  font-family: var(--button-emphasis-font-family, "DB Adman X");
  font-size: var(--button-emphasis-font-size, 20px);
  font-style: normal;
  font-weight: var(--button-emphasis-font-weight, 700);
  line-height: normal;
}

.symposium-stage-detail {
  padding-bottom: 22px;

  .stage-content {
    margin-bottom: 44px;

    h1 {
      padding: 22px 0;
      color: #212529;
      font-family: var(--h3-font-family, "DB HelvethaicaMon X");
      font-size: var(--h3-font-size, 48px);
      font-style: normal;
      font-weight: var(--h3-font-weight, 500);
      line-height: normal;
      text-align: center;
    }

    h2 {
      padding: 22px 0;
      line-height: 1;
    }

    .image {
      width: 100%;
      margin-bottom: 16px;
    }

    .title {
      display: flex;
      align-items: center;
      color: #DA0401;
      text-align: center;
      font-family: var(--h2-font-family, "DB HelvethaicaMon X");
      font-size: var(--h2-font-size, 60px);
      font-style: normal;
      font-weight: var(--h2-font-weight, 700);
      line-height: normal;
    }

    .title::before,
    .title::after {
      content: "";
      flex: 1;
      border-bottom: 8px solid #DA0401;
    }

    .title::before {
      margin-right: 0.25em;
    }

    .title::after {
      margin-left: 0.25em;
    }
  }

  .session-item {
    cursor: pointer;
    padding-bottom: var(--space-04, 16px);

    .thumbnail-session {
      width: 100%;
      aspect-ratio: 16 / 9;
    }

    .time-session {
      display: flex;
      padding: var(--space-02, 8px) var(--space-04, 16px);
      align-items: center;
      gap: var(--space-04, 16px);
      align-self: stretch;
      background: var(--baseColor-neutral-1000, #000);
      color: #fff;
      font-family: var(--h6-font-family, "DB HelvethaicaMon X");
      font-size: var(--h6-font-size, 28px);
      font-style: normal;
      font-weight: var(--h6-font-weight, 500);
      line-height: normal;
    }

    .session-content {
      display: flex;
      height: 315px;
      flex-direction: column;
      align-items: center;
      // gap: var(--space-02, 8px);
      background: #DA0401;
      color: #FFF;

      .topic {
        display: flex;
        padding: var(--space-04, 16px) var(--space-02, 16px) var(--space-00, 0px) var(--space-02, 16px);
        justify-content: flex-start;
        align-items: center;
        gap: var(--space-04, 16px);
        align-self: stretch;
        color: #FFF;
        text-align: left;
        /* button-upscale */
        font-family: var(--button-upscale-font-family, "DB Adman X");
        font-size: var(--button-upscale-font-size, 24px);
        font-style: normal;
        font-weight: var(--button-upscale-font-weight, 700);
        line-height: normal;
        // min-height: 94px;
        // max-height: 94px;
        white-space: wrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 8px;
      }

      .speaker {
        font-family: var(--label-font-family, Sarabun);
        display: flex;
        padding: var(--space-00, 0px) var(--space-02, 36px);
        // justify-content: center;
        // align-items: center;
        gap: var(--space-04, 16px);
        align-self: stretch;
      }
    }
  }

  .other-stage {
    margin-bottom: 44px;

    h1.title {
      color: #212529;

      /* h5-subheading */
      font-family: var(--h5-font-family, "DB HelvethaicaMon X");
      font-size: var(--h5-font-size, 32px);
      font-style: normal;
      font-weight: var(--h5-font-weight, 500);
      line-height: normal;
      margin-bottom: 24px;
    }
  }

  .section-next-day {
    margin-bottom: 44px;

    h1.title {
      color: #212529;

      /* h5-subheading */
      font-family: var(--h5-font-family, "DB HelvethaicaMon X");
      font-size: var(--h5-font-size, 32px);
      font-style: normal;
      font-weight: var(--h5-font-weight, 500);
      line-height: normal;
    }

    .stage {
      margin-bottom: 22px;
      flex-wrap: wrap;

      .content {
        cursor: pointer;
        padding-top: 12px;
        padding-bottom: 12px;

        img {
          width: 100%;
          height: auto;
          background-color: $light;
        }

        p {
          padding: 22px 0;
          line-height: 1;
          font-size: 1.25rem;
        }
      }
    }
  }

  @media (max-width: 600px) {

    .cus-breadcrumb {
      font-size: var(--body-upscale-font-size, 16px);
    }

    .cus-breadcrumb-active {
      font-size: var(--body-upscale-font-size, 16px);
    }

    .stage-content {
      h1 {
        font-size: var(--h3-font-size, 24px);
      }

      .title {
        font-size: var(--h2-font-size, 32px);
      }

    }

    .session-item {
      .time-session {
        font-size: 25.285px;
      }

      .session-content {
        height: 250px;

        .topic {
          font-size: 21.673px;
        }

        .speaker {
          font-size: 12.642px;
        }
      }
    }
  }

}
</style>
